let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lGQGv")).then(() => parcelRequire('c4uEB'));